const setRem = () => {
  // eslint-disable-next-line template-curly-spacing
  const scale = `${ document.documentElement.clientWidth / 1920 * 100 }px`
  document.documentElement.style.fontSize = scale
}

setRem()
window.onresize = function () {
  setRem()
}



// WEBPACK FOOTER //
// ./src/utils/rem.js